import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { Radium } from "higher-order-components"
import { Link } from "react-router-dom"
import COLOR_PALETTE from "constants/color-palette"
import { NotificationsIcon } from "components"
import TopNavigationItem from "./top-navigation-item"
import AnimatedDropdown from "./animated-dropdown"
import { PrimaryNavigationItem } from "./navigation-item"
import { dropdownWidth, breakpointTablet } from "../settings"
import buttonStyles from "AtomicComponents/Button/Button.less"
import { Interactive, Space } from "AtomicComponents"
import gtmHandler from "AtomicUtils/gtmHandler"

export const NotificationsButton = props => {
  return (
    <TopNavigationItem
      label={"Notifications"}
      Icon={NotificationsIcon}
      {...props}
      badge={props.notifications.length}
    />
  )
}

NotificationsButton.propTypes = {
  notifications: PropTypes.array
}

export const NotificationType = ({ item, isDropdown }) => {
  switch (item.notificationType) {
  case "RECALL":
    return (
      <span>
        <b>
            URGENT RECALL ON YOUR {item.namePlate} [{item.rego}]
        </b>.{isDropdown ? (
          <span>
            <br />
            <br />
          </span>
        ) : (
          " "
        )}
        {item.detailUrl && (
          <span>
            <Link
              to={item.detailUrl}
              style={{
                color: isDropdown ? COLOR_PALETTE.WHITE : COLOR_PALETTE.BLACK
              }}
            >
                View details about this recall
            </Link>{" "}
              or request a service now to rectify this issue.
          </span>
        )}
      </span>
    )

  case "ROADSIDE_EXPIRY":
    return (
      <span>
          Your <b>Roadside Assistance</b> policy for your{" "}
        <b>
          {item.namePlate} [{item.rego}]
        </b>{" "}
          will expire soon.{isDropdown ? (
          <span>
            <br />
            <br />
          </span>
        ) : (
          " "
        )}Call{" "}
        <a
          href={
            item.contactNumber &&
              `tel:${item.contactNumber.replace(/ /g, "")}`
          }
          style={{
            color: isDropdown ? COLOR_PALETTE.WHITE : COLOR_PALETTE.BLACK,
            whiteSpace: "nowrap"
          }}
        >
          {item.contactNumber}
        </a>{" "}
          to discuss a renewal or view your policy page for details.
      </span>
    )

  case "INSURANCE_EXPIRY":
    return (
      <span>
          Your <b>{item.policyTitle}</b> for your{" "}
        <b>
          {item.namePlate} [{item.rego}]
        </b>{" "}
          will expire soon.{isDropdown ? (
          <span>
            <br />
            <br />
          </span>
        ) : (
          " "
        )}Call{" "}
        <a
          href={
            item.contactNumber &&
              `tel:${item.contactNumber.replace(/ /g, "")}`
          }
          style={{
            color: isDropdown ? COLOR_PALETTE.WHITE : COLOR_PALETTE.BLACK,
            whiteSpace: "nowrap"
          }}
        >
          {item.contactNumber}
        </a>{" "}
          to discuss a renewal or view your policy page for details.
      </span>
    )

  case "SERVICE_DUE":
    return (
      <span>
          It looks like your{" "}
        <b>
          {item.namePlate} [{item.rego}]
        </b>{" "}
          is due for a service soon.
      </span>
    )

  case "SERVICE_OVERDUE":
    return (
      <span>
          It looks like your{" "}
        <b>
          {item.namePlate} [{item.rego}]
        </b>{" "}
          is overdue for a service.
      </span>
    )

  case "LINK_VEHICLE":
    return (
      <span>
          We have added your{" "}
        <b>
          {item.namePlate} [{item.rego}]
        </b>{" "}
          to your account.
      </span>
    )

  case "UNLINK_VEHICLE":
    return (
      <span>
          We have transferred the{" "}
        <b>
          {item.namePlate} [{item.rego}]
        </b>{" "}
          from your account.{isDropdown ? (
          <span>
            <br />
            <br />
          </span>
        ) : (
          " "
        )}For further enquiries contact us online or phone{" "}
        <a
          href={
            item.contactNumber &&
              `tel:${item.contactNumber.replace(/ /g, "")}`
          }
          style={{
            color: isDropdown ? COLOR_PALETTE.WHITE : COLOR_PALETTE.BLACK,
            whiteSpace: "nowrap"
          }}
        >
          {item.contactNumber}
        </a>.
      </span>
    )

  case "USER_DETAILS_UPDATE":
    return (
      <span>
          Your personal details have recently been updated. You can review and
          update these on the Manage Account page.
      </span>
    )

  default:
    return null
  }
}

const NotificationsDropdown = ({
  open,
  buttonUrl,
  buttonLinkText,
  notifications
}) => (
  <AnimatedDropdown open={open}>
    <div style={style.menu}>
      {notifications.length ? (
        notifications.map((item, index) => (
          <div
            key={index}
            style={{
              borderBottom: "1px solid #545454",
              color: COLOR_PALETTE.WHITE,
              padding: "1em 3em 1.5em"
            }}
          >
            <p style={{ lineHeight: "21px", fontWeight: "200" }}>
              {item.notificationStatus === "NEW" && (
                <span
                  style={{
                    display: "inline-block",
                    width: "10px",
                    height: "10px",
                    borderRadius: "10px",
                    margin: "0 10px 0 -20px",
                    background: COLOR_PALETTE.RED
                  }}
                />
              )}
              <NotificationType item={item} isDropdown />
            </p>
            {item.buttonUrl && item.buttonLinkText && (
              <Link to={item.buttonUrl} style={{ textDecoration: "none" }}>
                <span
                  className={`Button ${classnames({
                    [buttonStyles.Button]: true,
                    [buttonStyles.ButtonFullWidth]: true,
                    [buttonStyles.ButtonWhiteOutlined]: item.notificationType !== "RECALL",
                    [buttonStyles.ButtonRed]: item.notificationType === "RECALL"
                  })}`}
                  onClick={() => {
                    gtmHandler({
                      pageCategory: "MyMazda - Notifications",
                      pageAction: `Drop down "${item.notificationType}" - clicked "${item.buttonLinkText.toUpperCase()}"`
                    })
                  }}
                >{item.buttonLinkText}</span>
              </Link>
            )}
            <Space />
            <Interactive>{item.notificationDate}</Interactive>
          </div>
        ))
      ) : (
        <p
          style={{
            color: COLOR_PALETTE.GRAY_DARK,
            padding: "3.5em 0",
            margin: "0",
            textAlign: "center",
            borderBottom: "1px solid #545454"
          }}
        >
          No unread notifications.
        </p>
      )}
      {
        <div style={{ textAlign: "center" }}>
          <PrimaryNavigationItem
            href={buttonUrl}
            label={buttonLinkText}
            fullReload={false}
          />
        </div>
      }
    </div>
  </AnimatedDropdown>
)

const style = {
  menu: {
    background: COLOR_PALETTE.GRAY3,
    marginLeft: "auto",
    width: "100%",
    maxHeight: "calc(100vh - 9rem)",
    overflow: "auto",
    [breakpointTablet]: {
      width: dropdownWidth,
      maxHeight: "calc(100vh - 4.5rem)"
    }
  }
}

NotificationsDropdown.propTypes = {
  open: PropTypes.bool,
  buttonUrl: PropTypes.string,
  buttonLinkText: PropTypes.string,
  notifications: PropTypes.array
}

export default Radium(NotificationsDropdown)



// WEBPACK FOOTER //
// ./src/containers/mymazda/navigation/notifications.jsx